/** Origine du formulaire adresse — détermine la redirection après enregistrement. */
export type AddressFormOrigin = "addresses" | "order";

const ORIGINS: AddressFormOrigin[] = ["addresses", "order"];

export function parseAddressFormOrigin(
  searchParams: URLSearchParams,
): AddressFormOrigin {
  const from = searchParams.get("from");
  return ORIGINS.includes(from as AddressFormOrigin) ? (from as AddressFormOrigin) : "addresses";
}

export function getReturnPath(origin: AddressFormOrigin): string {
  return origin === "order" ? "/client/order/new" : "/client/account/addresses";
}

export function buildAddressFormPath(
  mode: "new" | "edit",
  origin: AddressFormOrigin,
  addressId?: string,
): string {
  const query = `?from=${origin}`;
  if (mode === "new") {
    return `/client/account/addresses/new${query}`;
  }
  return `/client/account/addresses/${addressId}/edit${query}`;
}
